import { Component, computed, DestroyRef, effect, inject, signal } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormDisplayControl } from "@oi-soft/common";
import { ButtonGenericComponent } from "@shared/components/buttons/button-generic/button-generic.component";
import { TooltipDirective } from "@shared/directives/tooltip/tooltip.directive";
import { Subscription } from "rxjs";
import { FooterToolbarSaveButtonService } from "./footer-toolbar-save-button.service";

@Component({
    selector: 'app-footer-toolbar-save-button',
    imports: [FontAwesomeModule, TooltipDirective, ButtonGenericComponent],
    templateUrl: './footer-toolbar-save-button.component.html',
    styleUrl: './footer-toolbar-save-button.component.scss',
})
export class FooterToolbarSaveButtonComponent {

    private footerToolBarSaveButtonService = inject(FooterToolbarSaveButtonService);
    private destroyRef = inject(DestroyRef);
    
    errorCount = signal<number>(0);
    warningCount = signal<number>(0);

    validitySubscription:Subscription|undefined;

    form = computed(() => {
        return this.footerToolBarSaveButtonService.visibleTrigger()?.form?.();
    })
    
    isFormEditable = computed(() => {

        const formControls = this.form()?.controls;

        if(formControls){
            return Object.keys(formControls).some((controlKey) => formControls[controlKey].enabled);
        }
        else{
            return false;
        }
    })

    constructor(){
        
        effect(()=>{

            if(this.validitySubscription){
                this.validitySubscription.unsubscribe();
            }

            const form = this.form();

            if(form){
                this.validitySubscription?.unsubscribe();

                this.validitySubscription = form.statusChanges
                .subscribe({
                    next: () => {
                        let validityCheck = this.runValidityCheck(form);
                        this.errorCount.set(validityCheck.errors);
                        this.warningCount.set(validityCheck.warnings);
                    }
                })

                this.destroyRef.onDestroy(() => {
                    this.validitySubscription?.unsubscribe();
                })

            }
        })
    }
    
    onSave(){
        this.footerToolBarSaveButtonService.triggerSaveButtonOnSave();
    }

    private runValidityCheck(form:FormGroup){
        let errorCount = 0;
        let warningCount = 0;

        Object.keys(form.controls).forEach(key => {

            let formChild = form.get(key)!;

            if(formChild instanceof FormDisplayControl){
                if(formChild.dirty || formChild.touched){ 
                    if(formChild.errors){
                        errorCount += 1;
                    }
                    if(formChild.warnings){
                        warningCount += 1;
                    }
                }
            }
            else if(formChild instanceof FormGroup){
                let validity = this.runValidityCheck(formChild);
                errorCount += validity.errors;
                warningCount += validity.warnings;
            }
            
        });

        return {errors: errorCount, warnings: warningCount};
    }
}
